import { TriangleAlert } from "lucide-react";

const ConfirmModal = ({ isOpen, title, message, onConfirm, onConfirmTitle, onCancel, onCancelTitle, button = "red", count = 0 }) => {
  if (!isOpen) return null;

  const colorMap = {
    red: {
      icon: "text-red-400",
      btn: "bg-red-600 hover:bg-red-700",
    },
    blue: {
      icon: "text-blue-400",
      btn: "bg-blue-600 hover:bg-blue-700",
    },
    green: {
      icon: "text-green-400",
      btn: "bg-green-600 hover:bg-green-700",
    },
    yellow: {
      icon: "text-yellow-400",
      btn: "bg-yellow-600 hover:bg-yellow-700",
    },
    gray: {
      icon: "text-gray-400",
      btn: "bg-gray-600 hover:bg-gray-700",
    },
  };

  const selectedColor = colorMap[button] || colorMap.red;

  const finalTitle = count > 1 ? `Confirm Delete (${count} Records)` : title || "Confirm Delete";
  const finalMessage = count > 1 ? `Are you sure you want to delete these ${count} records? This action cannot be undone.` : message;

  return (
    <div className="!fixed !inset-0 !flex !items-center !justify-center !bg-black/50 z-50">
      <div className="!bg-white !rounded-sm !shadow-xl !w-full !max-w-sm">
        <div className="!text-xl !font-normal !text-gray-500 !mb-3 !border-b !border-gray-200 !py-3 !px-6 text-left flex !space-x-2 item-center justify-left">
          <TriangleAlert className={selectedColor.icon} />
          <p>{finalTitle}</p>
        </div>
        <p className="!text-gray-600">{finalMessage}</p>
        <div className="!flex !justify-center !gap-3 !py-3 !px-10">
          <button onClick={onCancel} className="!px-6 !py-2 !rounded-lg !border !border-gray-300 !text-gray-700 hover:!bg-gray-100 !transition cursor-pointer">
            {onCancelTitle}
          </button>
          <button onClick={onConfirm} className={`!px-6 !py-2 !rounded-lg !text-white ${selectedColor.btn} !transition cursor-pointer`}>
            {onConfirmTitle}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
